@if (activityRecord.can_add_pickup) {
  <div class="add-pickup">
    <a data-cy="add-pickup" (click)="addPickup()">
      <img src="assets/images/icons/pickup-active.svg" />
      <span class="spen-util-link">ピックアップを追加する</span>
    </a>
  </div>
} @else {
  @if (pickupsLoaded && pickups.length > 0) {
    <p class="permission-message">※課題配信先のスペースを担当していないためピックアップできません。</p>
  }
}

@if (pickupsLoaded) {
  @if (pickups.length > 0) {
    <div class="pickups-list">
      @for (pickup of pickups; track pickup.id) {
        <app-teacher-pickup-item [pickup]="pickup"></app-teacher-pickup-item>
      }
    </div>
  } @else {
    <div class="empty-message">ここにピックアップが表示されます。</div>
  }
  @if (canLoadMore) {
    <div class="load-more">
      <a class="spen-util-link" (click)="loadMorePickups()">
        <span>もっと見る</span>
        <i [class]="isLoadingMore ? 'fa fa-spinner fa-spin' : 'fa fa-chevron-down'"></i>
      </a>
    </div>
  }
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
